var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tickets"},[_c('message',{attrs:{"data":_vm.infoMessage}}),_c('tickets-table',{attrs:{"tickets":_vm.proposal.tickets,"proposal":_vm.proposal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }